import { render, staticRenderFns } from "./CustomerActivities.vue?vue&type=template&id=0257e489&scoped=true"
import script from "./CustomerActivities.vue?vue&type=script&lang=js"
export * from "./CustomerActivities.vue?vue&type=script&lang=js"
import style0 from "./CustomerActivities.vue?vue&type=style&index=0&id=0257e489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257e489",
  null
  
)

export default component.exports